import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import WaterfallFlow from 'components/Flows/WaterfallFlows/WaterfallFlows';
import WaterfallAnalysisDrawer from 'components/Analyses/WaterfallAnalyses/Drawer/Drawer';

const WaterfallFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <WaterfallAnalysisDrawer />
      <WaterfallFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <WaterfallFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);